const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
import { itemFilterUrlSearchSchema } from '@/lib/zod-schemas/itemFilterUrlSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

// `teamId` is no longer declared separately here — it's folded into the shared
// itemFilterUrlSearchSchema below, so a team-scoped portfolio link and an ad-hoc
// team filter applied from the toolbar are the same URL param, not two competing ones.
const portfolioSearchSchema = itemFilterUrlSearchSchema.extend({
  ...itemPanelSearchSchema.shape,
  // Reserved for follow-up saved-views/recommendation work; validated but unused for now.
  filterSetId: z.string().optional(),
  fromRecommendation: z.string().optional(),
  selectAll: z.preprocess((v: unknown) => v === 'true' || v === true, z.boolean().optional()).optional(),
  createInstance: z.string().optional(),
  oauthCredentialsId: z.number().optional(),
  loopId: z.number().optional(),
  callbackSource: z.string().optional()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(portfolioSearchSchema),
  beforeLoad: requirePermission('edit_planner'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.portfolio)
    }
  }
});